import React from 'react';
import _ from 'lodash';
import { Row, Col } from 'grab-ui';
import CampaignDetailMetricsCard from './CampaignCommsMetricsCard';
import CampaignCommsMetricsTable from './CampaignCommsMetricsTable';

const CampaignCommsMetricsView = ({ tableView, metrics }) => {
  return (
    <div>
      {tableView ? (
        <CampaignCommsMetricsTable metrics={metrics} />
      ) : (
        <div>
          <Row style={{ marginTop: 0 }}>
            {_.map(metrics, (channelMetrics, key) => (
              <Col className="campaign-metric-card" span={12} key={key}>
                <CampaignDetailMetricsCard
                  metrics={channelMetrics}
                  name={key}
                />
              </Col>
            ))}
          </Row>
        </div>
      )}
    </div>
  );
};

export default CampaignCommsMetricsView;
